/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationAdminRemoveGroup
 */
export interface OrganizationAdminRemoveGroup {
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminRemoveGroup
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminRemoveGroup
     */
    old_group_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminRemoveGroup
     */
    organization_azure_id: string;
}

/**
 * Check if a given object implements the OrganizationAdminRemoveGroup interface.
 */
export function instanceOfOrganizationAdminRemoveGroup(value: object): value is OrganizationAdminRemoveGroup {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('old_group_name' in value) || value['old_group_name'] === undefined) return false;
    if (!('organization_azure_id' in value) || value['organization_azure_id'] === undefined) return false;
    return true;
}

export function OrganizationAdminRemoveGroupFromJSON(json: any): OrganizationAdminRemoveGroup {
    return OrganizationAdminRemoveGroupFromJSONTyped(json, false);
}

export function OrganizationAdminRemoveGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationAdminRemoveGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'old_group_name': json['old_group_name'],
        'organization_azure_id': json['organization_azure_id'],
    };
}

export function OrganizationAdminRemoveGroupToJSON(json: any): OrganizationAdminRemoveGroup {
    return OrganizationAdminRemoveGroupToJSONTyped(json, false);
}

export function OrganizationAdminRemoveGroupToJSONTyped(value?: OrganizationAdminRemoveGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'old_group_name': value['old_group_name'],
        'organization_azure_id': value['organization_azure_id'],
    };
}

